import { FC, memo } from 'react';

import { dom } from 'app/utils';
import { useSource } from 'app/hooks';
import { ILookup } from 'app/models';
import { Dropdown as Component, DropdownProps as Props } from '../external';
import { ISource } from '../types';
import { IInput } from './types';

export interface ISelect extends IInput {
  editable?: boolean;
  filterable?: boolean;
  checkmark?: boolean;
  loading?: boolean;

  options?: ILookup[];
  source?: ISource['type'] | ISource;
}

export const Select: FC<ISelect> = memo(({ id, className, style, disabled, name, value, invalid, tabIndex, placeholder, tooltip, autoFocus, clearable, readOnly, editable, filterable, checkmark, loading, options, source, onBlur, onChange, onFocus }) => {
  if (!source || typeof source === 'string') source = { type: (source ?? 'static') };

  const state = useSource(source, { loading, options });
  const select: Props = { ...state, id, style, disabled, name, value, invalid, tabIndex, placeholder, tooltip, autoFocus, readOnly, editable, checkmark, onBlur, onFocus,
    className: dom.className('i-component', 'i-input', 'i-select', { 'i-invalid': invalid }, className),

    autoOptionFocus: true,
    showClear: clearable,
    filter: filterable,
    virtualScrollerOptions: (state.options?.length > 20 ? { itemSize: 38, autoSize: true, loading: state.loading } : undefined),

    onChange: onChange as any,
  };

  return (
    <Component { ...select } />
  );
});
